import { CHANNEL_STATUS, PROTOCOL } from '@/entities/channel';

export const CHANNELS_STATUS_TO_I18_KEY = {
  [CHANNEL_STATUS.ACTIVE]: 'channels:status.unauthorized',
  [CHANNEL_STATUS.INACTIVE]: 'channels:status.authRequired',
  [CHANNEL_STATUS.PENDING_PAYMENT]: 'channels:status.pendingPayment',
  [CHANNEL_STATUS.CONTACTS_SYNCED]: 'channels:status.syncingChats',
  [CHANNEL_STATUS.CHATS_SYNCED]: 'channels:status.syncingChats',
  [CHANNEL_STATUS.READY]: 'channels:status.ready',
  [CHANNEL_STATUS.AUTHORIZED]: 'channels:status.syncingContacts',
  [CHANNEL_STATUS.QR_IN_PROGRESS]: 'channels:status.qrInProgress',
  [CHANNEL_STATUS.UNAUTHORIZED]: 'channels:status.unauthorized',
  [CHANNEL_STATUS.PASSWORD_REQUIRED]: 'channels:status.passwordRequired',
  [CHANNEL_STATUS.REQUIRED_SCAN_QR]: 'channels:status.qrInProgress',
  [CHANNEL_STATUS.SMS_SENT]: 'channels:status.smsSent',
  [CHANNEL_STATUS.SUSPENDED]: 'channels:status.suspended',
} as const;

export const PROTOCOL_TO_LOGO = {
  [PROTOCOL.TELEGRAM_BOT]: 'telegramBot',
  [PROTOCOL.TELEGRAM_PERSONAL]: 'telegram',
  [PROTOCOL.WHATSAPP_GRAY]: 'whatsapp',
  [PROTOCOL.WABA]: 'whatsapp',
  [PROTOCOL.INFOBIP]: 'infobip',
  [PROTOCOL.MAX]: 'max-bot',
  [PROTOCOL.MAX_PERSONAL]: 'max',
  [PROTOCOL.AVITO]: 'avito',
  [PROTOCOL.WILDBERRIES]: 'wildberries',
  [PROTOCOL.OZON]: 'ozon',
  [PROTOCOL.VK]: 'vk',
} as const;
